import { giphyBlack, giphyWhite } from '@giphy/js-brand'
import { Gif, Grid as SDKGrid } from '@giphy/react-components'
import styled, { css, keyframes } from 'styled-components'
import { AppConfig, MARGIN } from '../constants'
import { isPercy } from '../env'

export const AppContainer = styled.div<{ config: AppConfig; showBorderRadius?: boolean }>`
    background: ${giphyBlack};
    color: ${giphyWhite};
    font-family: 'interface', 'Helvetica Neue', helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 15px;
    height: ${(props) => (props.config.flexVertical ? `100%` : `${props.config.height}px`)};
    width: ${(props) => props.config.width}px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    ${(props) =>
        props.showBorderRadius &&
        css`
            border-radius: 10px;
        `}
    border: 0 thin red;
`

export const ContentContainer = styled.div`
    flex: 1;
    flex-shrink: 0;
    position: relative;
    display: flex;
    flex-direction: column;
`

export const CheckeredBackground = styled.div<{ isStickerGrid: boolean; appWidth: number }>`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4AQMAAACSSKldAAAABlBMVEUhIiIWFhYoSqvJAAAAGElEQVQY02MAAv7///8PWxqIPwDZw5UGABtgwz2xhFKxAAAAAElFTkSuQmCC');
    background-size: ${(props) => props.appWidth / 10}px;
    ${(props) =>
        props.isStickerGrid &&
        css`
            opacity: 1;
        `}
`
export const GridContainer = styled.div<{ isVisible: boolean }>`
    flex-grow: 1;
    min-height: 0;
    height: 0;
    position: relative;
    display: flex;
    ${(props) =>
        !props.isVisible &&
        css`
            display: none;
        `}
`
const growIn = keyframes`
    0% {
      transform: scale(0.6);
      opacity: 0;
    };  
    
    100% {
        transform: scale(1);
        opacity: 1;
    }
`
export const Grid = styled(SDKGrid)<{ width: number; padding: number; marginTop: number }>`
    min-width: ${(props) => props.width}px;
    padding: ${(props) => props.padding}px ${(props) => props.padding / 2}px;
    margin-top: ${(props) => props.marginTop}px;
    .${SDKGrid.loaderClassName} {
        transform: scale(0.7);
    }
    ${(props) =>
        props.padding &&
        !isPercy &&
        css`
            .${Gif.imgClassName} {
                transform: scale(0.6);
                opacity: 0;
            }
            .${Gif.imgLoadedClassName} {
                animation: ${growIn} ease-out 250ms forwards;
            }
        `}
`

export const GifDetailContainer = styled(GridContainer)`
    width: 100%;
`

export const StyledScrollContainer = styled.div`
    margin: 0 ${MARGIN}px;
    overflow-y: auto;
    overflow-x: hidden;
    flex-grow: 1;
    position: relative;
    ::-webkit-scrollbar {
        display: none;
    }
`
